import AggregatorType from "../enums/AggregatorType.js";

/**
 * Based on https://flightscope.atlassian.net/browse/BBP-482?focusedCommentId=45029
 */
class RankingStat {
    constructor(parameter, value, aggregator, weight) {
        if (typeof(parameter) !== 'string' || !parameter) {
            throw new TypeError('parameter must be a string and cannot be empty');
        }

        this.parameter = parameter;

        if (typeof(value) === 'undefined' && Number.isNaN(value)) {
            throw new TypeError('value must be an number');
        }

        this.value = value;

        if (typeof(aggregator) !== 'string' || !aggregator) {
            throw new TypeError('aggregator must be a string and cannot be empty');
        }

        this.aggregator = aggregator;

        if (!Number.isInteger(weight) || weight < 0) {
            throw new TypeError('weight must be an integer greater than or equal 0');
        }

        this.weight = weight;
    }

    isEmpty() {
        return this.value === null || Number.isNaN(this.value);
    }

    static fromParameter(parameterObject, value, weight) {
        if (
            typeof(parameterObject) !== 'object'
            || !parameterObject.hasOwnProperty('key')
            || !parameterObject.hasOwnProperty('aggregator')
        ) {
            throw new TypeError('parameterObject must be an object with key and aggregator properties');
        }

        return new RankingStat(
            parameterObject.key, value, parameterObject.aggregator, weight
        );
    }

    static fromObject(rankingStatObject) {
        if (typeof(rankingStatObject) !== 'object') {
            throw new TypeError('only objects are supported');
        }

        return new RankingStat(
            rankingStatObject.parameter,
            rankingStatObject.value,
            rankingStatObject.aggregator,
            rankingStatObject.weight
        );
    }

    static getDefault(parameterObject, weight) {
        if (
            typeof(parameterObject) !== 'object'
            || !parameterObject.hasOwnProperty('key')
            || !parameterObject.hasOwnProperty('aggregator')
        ) {
            throw new TypeError('parameterObject must be an object with key and aggregator properties');
        }

        let value = null;
        switch (parameterObject.aggregator) {
            case AggregatorType.AVG.key:
            case AggregatorType.MAX.key:
            case AggregatorType.MIN.key:
                value = null;
                break;

            case AggregatorType.SUM.key:
            case AggregatorType.COUNT.key:
                value = 0;
                break;
        
            default:
                throw new TypeError(`unknown type of aggregator - ${parameterObject.aggregator}`);
        }

        return RankingStat.fromParameter(
            parameterObject, value, weight
        );
    }
}

export default RankingStat;